import "vuetify/styles"; // Ensure you are using css-loader
import { createVuetify } from "vuetify";
import { aliases, mdi } from "vuetify/iconsets/mdi";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import { hu } from "vuetify/locale";

/**
 * Cégvándor brand palette, mirroring the marketing site
 * (~/projects/cegvandor — src/main.ts). Kept in sync with the CSS custom
 * properties in src/assets/brand.css; change both together.
 */
const cegvandorLight = {
  dark: false,
  colors: {
    background: "#f8f9fe",
    surface: "#ffffff",

    primary: "#22288d",
    "primary-darken-1": "#191d69",
    secondary: "#5b62c4",

    // Status colours, warmed slightly to sit next to the indigo brand.
    success: "#2e7d54",
    info: "#22288d",
    warning: "#c77700",
    error: "#c62828",

    "on-background": "#111827",
    "on-surface": "#111827",
    "on-primary": "#ffffff",
  },
};

export default createVuetify({
  components, // Include all components
  directives,
  locale: {
    locale: "hu", // set default locale to Hungarian
    messages: { hu }, // provide the messages
  },
  icons: {
    defaultSet: "mdi",
    aliases,
    sets: {
      mdi,
    },
  },
  theme: {
    defaultTheme: "cegvandorLight",
    themes: { cegvandorLight },
  },
  /**
   * App-wide component defaults so individual views stop hand-rolling
   * variant/elevation/density and drift apart. Anything set on a component
   * directly still wins.
   */
  defaults: {
    VCard: {
      rounded: "lg",
      elevation: 0,
      border: true,
    },
    VBtn: {
      rounded: "lg",
      elevation: 0,
    },
    VTextField: {
      variant: "outlined",
      density: "comfortable",
      color: "primary",
    },
    VTextarea: {
      variant: "outlined",
      density: "comfortable",
      color: "primary",
    },
    VSelect: {
      variant: "outlined",
      density: "comfortable",
      color: "primary",
    },
    VCombobox: {
      variant: "outlined",
      density: "comfortable",
      color: "primary",
    },
    VAutocomplete: {
      variant: "outlined",
      density: "comfortable",
      color: "primary",
    },
    VChip: {
      rounded: "lg",
    },
    VAlert: {
      rounded: "lg",
    },
    VDialog: {
      VCard: { border: false },
    },
    VList: {
      rounded: "lg",
    },
  },
});
